<template>
  <div class="unassigned">
    <div class="unassigned__header">
      <h2 class="medium-title">Unassigned Ticket</h2>
    </div>
    <div v-if="!isLoading" class="unassigned__main">
      <table v-if="listUnassigned.length > 0" class="table-unassigned">
        <tr>
          <th>City</th>
          <th>Ticket</th>
        </tr>
        <tr v-for="(item, index) in listUnassigned" :key="index">
          <td class="center">{{item.city}}</td>
          <td class="center">{{item.count}}</td>
        </tr>
      </table>
      <div v-else class="unassigned__main__empty">
        <adx-empty />
      </div>
    </div>
    <div v-else class="unassigned__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-unassigned-ticket',
  components: {
    'adx-loading': Loading,
    'adx-empty': EmptySelection
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      listUnassigned: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.getListUnassigned();
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getListUnassigned() {
      (async () => {
        this.isLoading = true
        const response = await api.get(apiV2.unassginedTicket, {needToken: true})
        if (response.status == 200) {
          this.listUnassigned = response.data
        }
        this.isLoading = false
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
